<template>
    <div>
      <!-- 返回 开始 -->
      <div class="page_topbox">
        <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
        <div class="page_toptext">预约详情</div>
        <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
      </div>
      <!-- 返回 结束 -->
        <!--detail.wxml-->
        <div class="page_top detailbook_list_top">
          <div class="detailbook_icon">
            <img src="/static/daichuli.png" class="detailbook_iconimg" />
            <!-- 订单状态待施工 -->
            <span v-if="info.status==1" class="detailbook_icon_text">待处理…</span>
          </div>
        </div>
        <div class="detailbook_preview">
            <div class="detailbook_preview_bd">
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">卡券名称</div>
                    <div class="detailbook_preview_value">{{info.product && info.product.name}}</div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">卡券编号</div>
                    <div class="detailbook_preview_value">{{info.card_no}}</div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">订单时间</div>
                    <div class="detailbook_preview_value">{{info.created_at}}</div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">订单编号</div>
                    <div class="detailbook_preview_value">{{info.book && info.book.code}}</div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">预约日期</div>
                    <div class="detailbook_preview_value">{{info.book && info.book.subscribe_time}}</div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">预约项目</div>
                    <div class="detailbook_preview_value">{{info.book && info.book.product_item ? info.book.product_item.name :
                       info.product && info.product.name}}
                    </div>
                </div>
                <div class="detailbook_preview_item">
                    <div class="detailbook_preview_label">预约店铺</div>
                    <div class="detailbook_preview_value">{{info.book && info.book.store.name}}</div>
                </div>
                <div class="detailbook_preview_item" v-if="info.book && info.book.user_car">
                    <div class="detailbook_preview_label">车牌号</div>
                    <div class="detailbook_preview_value">{{info.book &&  info.book.user_car && info.book.user_car.car_no}}</div>
                </div>
            </div>
            <div class="detailbook_preview_ft">
                <router-link to="/" class="detailbook_preview_btn detailbook_preview_btn_primary"
                             hover-class="detailbook_preview_btn_active">返回首页
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import httper from '../../api/http';

    export default {
        data() {
            return {
                id: '', // 上一页获取的卡券编号,默认为空
                info: {}, // 接口获取的卡券详情,默认为空
            }
        },
        created() {
          console.log("this.$route.query.id",this.$route.query.id)
          if(this.$route.query.id){
            this.id = this.$route.query.id
          }else{
            this.id = ""
          }
            // this.id = this.$route.query.id ? Number(this.$route.query.id) : ''
            console.log(this.id)
        },
        mounted() {
            if (!this.id) return
            let requestData = {
                id: this.id
            }
            this.request('getCouponDetail', requestData)
        },
        methods: {
          pageReturn(){
            this.$router.go(-1)
          },
          pageToIndex(){
            this.$router.push({
              path:"/"
            })
          },
            // // 点击触发
            //  tap(e) {
            //    let currentTarget = e.currentTarget
            //    let dataset = currentTarget.dataset
            //    let data = {}
            //    let requestData = {}
            //    switch (currentTarget.id) {
            //      case '':break
            //    }
            //  },

            // 调用接口
            request(type = '', requestData = {}) {
                let that = this
                let data = {}
                switch (type) {
                    // 获取卡券详情
                    case 'getCouponDetail':
                        httper.get('coupon/package-detail', requestData, res => {
                            console.log('卡券详情', res.data)
                            this.info = res.data
                        })
                        break
                }
            },

        }
    }
</script>

<style scoped>
    /**detail.wxss**/
    /* icon */
    .icon {
        padding: 27.5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #999;
        background-color: #fff;
    }

    /*  .icon image {
        width: 100rpx;
        height: 100rpx;
        margin-bottom: 30rpx;
      } */
    .iconimg {
        width: 100 rpx;
        height: 100 rpx;
        margin-bottom: 30 rpx;
    }
    .detailbook_list_top {
      background-image: url(../../../static/newprojecticon/zhifubg.png);
      background-size: contain;
      height: 153px;
    }

    .detailbook_icon {
      width: 100%;
      height: 35%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .detailbook_iconimg {
      width: 40px;
      height: 40px;
      margin-bottom: 15px;
    }

    .detailbook_icon_text {
      font-size: 15px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .detailbook_preview {
      position: relative;
      background-color: #fff;
      position: absolute;
      top: 180px;
      width: 90%;
      margin: 0 20px;
      box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
      border-radius: 0px 0px 8px 8px;
    }

    .detailbook_preview:before {
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 1px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      color: rgba(0, 0, 0, 0.1);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }

    .detailbook_preview_bd {
      padding: 16px;
      font-size: 0.9em;
      text-align: right;
      color: rgba(0, 0, 0, 0.5);
      line-height: 2;
    }

    .detailbook_preview_item {
      overflow: hidden;
    }

    .detailbook_preview_label {
      float: left;
      margin-right: 1em;
      min-width: 4em;
      color: rgba(0, 0, 0, 0.5);
      text-align: justify;
      -moz-text-align-last: justify;
      text-align-last: justify;
    }

    .detailbook_preview_value {
      display: block;
      overflow: hidden;
      word-break: normal;
      word-wrap: break-word;
      color: rgba(0, 0, 0, 0.9);
    }

    .detailbook_preview_ft {
      position: relative;
      line-height: 50px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }

    .detailbook_preview:after {
      content: " ";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      height: 1px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      color: rgba(0, 0, 0, 0.1);
      -webkit-transform-origin: 0 100%;
      transform-origin: 0 100%;
      transform: scaleY(0.5);
    }

    .detailbook_preview_btn_primary {

    }

    .detailbook_preview_btn {
      position: relative;
      display: block;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      text-align: center;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/detailBook.vue